export default {
  methods: {
    setupPaymentChecker(url) {
			let interval = 0;
			let attemptCount = 7;
			let attemptNumber = 0;
			let attemptInterval = 1500;
			let request = () => {
				++attemptNumber;
				let promise = this.axios.get(url);
				promise.then(response => {
					let data = response.data;
					if (data.completed) {
						clearInterval(interval);
						this.succeeded = true;
						this.loading = false;
					} else if (attemptNumber > attemptCount) {
						clearInterval(interval);
						this.succeeded = false;
						this.loading = false;
					}
				});
			}
			interval = window.setInterval(request, attemptInterval);
			request();
    },
  }
}